import { c as _c } from "react/compiler-runtime";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
export function MoreDots(t0) {
  const $ = _c(5);
  const {
    onClick,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = {
      color
    };
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick || $[3] !== t1) {
    t2 = <MoreHorizIcon sx={t1} aria-label="More Information" onClick={onClick} />;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}